import { gql } from '@apollo/client'
import {
  BASE_USER_FIELDS,
  POST_ITEM_FIELDS_FORLIST,
  POST_ITEM_USER,
} from './fragments'

export const FOLLOW = gql`
  mutation follow($param: FollowInput) {
    status: follow(input: $param)
  }
`

export const UN_FOLLOW = gql`
  mutation followCancel($param: FollowCancelInput) {
    status: followCancel(input: $param)
  }
`
/** 关注列表 */
export const GET_FOLLOWING_LIST = gql`
  ${BASE_USER_FIELDS}
  query followList($first: Int, $offset: Int, $param: FollowListInput) {
    followList(param: $param, page: { first: $first, offset: $offset }) {
      edges {
        node {
          ...baseUserFields
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
        totalCount
      }
    }
  }
`

/** 粉丝列表 */
export const GET_FOLLOWER_LIST = gql`
  ${BASE_USER_FIELDS}
  query fanList($first: Int, $offset: Int, $param: FansListInput) {
    fansList(param: $param, page: { first: $first, offset: $offset }) {
      edges {
        node {
          ...baseUserFields
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
        totalCount
      }
    }
  }
`

/**我的收藏/点赞 */
export const GET_FAV_OR_LIKE_LIST = gql`
  ${POST_ITEM_FIELDS_FORLIST}
  ${POST_ITEM_USER}
  query favOrLikeList(
    $offset: Int
    $first: Int
    $param: ArtworkSocialQueryInput!
  ) {
    squareModule {
      basePostSocialRelationshipList(
        page: { first: $first, offset: $offset }
        param: $param
      ) {
        edges {
          node {
            ...postItemFieldsForList
            ... on SquarePost {
              user {
                ...postItemUser
              }
              aiCollection {
                aiArtworkCount
                coverAiArtworks {
                  id
                  miniArtWorkUrl
                }
              }
            }
            type
          }
        }
        pageInfo {
          hasNextPage
        }
      }
    }
  }
`
